import { useEffect, useState } from 'react'
import { Icon } from '@iconify/react'
import { Overlay } from '../styles/ConfirmPinModalStyle'
import { Body, Dialog, Divider, Footer, Header } from '../styles/BlockUserModalStyle'

interface Props {
   open: boolean
   title: string
   message: string
   confirmText?: string
   onClose: () => void
   onConfirm: () => Promise<void>
}

export default function ConfirmActionModal({ open, title, message, confirmText = 'Confirm', onClose, onConfirm }: Props) {
   const [loading, setLoading] = useState(false)

   const handleConfirm = async () => {
      setLoading(true)
      await onConfirm()
      setLoading(false)
   }
   useEffect(() => {
      function esc(e: KeyboardEvent) { if (e.key === 'Escape') onClose() }
      if (open) window.addEventListener('keydown', esc)
      return () => window.removeEventListener('keydown', esc)
   }, [open, onClose])

   if (!open) return null

   return (
      <Overlay onClick={onClose}>
         <Dialog onClick={e => e.stopPropagation()} role='dialog' aria-modal='true'>
            <Header>
               <h2>
                  <Icon icon='solar:question-circle-linear' width={18} className='text-[#AF7AD5]' />
                  {title}
               </h2>
               <button aria-label='Close' onClick={onClose}><Icon icon='material-symbols:close' width={20} /></button>
            </Header>
            <Body>
               <p>{message}</p>
            </Body>
            <Divider />
            <Footer>
               <button className='cancel' onClick={onClose} disabled={loading}>Cancel</button>
               <button className='danger' onClick={handleConfirm} disabled={loading}>{loading ? 'Processing...' : confirmText}</button>
            </Footer>
         </Dialog>
      </Overlay>
   )
}
